import { API } from 'aws-amplify';

export interface Contract {
  id: number;
  timesheet_work_type?: string;
  [key: string]: any;
}

/**
 * Fetches contract information by ID
 * @param contractId The contract ID to fetch
 * @returns Promise<Contract | null>
 */
export const fetchContractById = async (contractId: number): Promise<Contract | null> => {
  try {
    const contract = await API.get(
      'EhcmsPortalApi',
      `/contractor/contracts/${contractId}`,
      {
        queryStringParameters: {
          fields: 'id,timesheet_work_type'
        }
      }
    ) as Contract;
    return contract;
  } catch (error) {
    console.error('Error fetching contract:', error);
    return null;
  }
};

/**
 * Checks if the contract has shifts work type
 * @param contract The contract object
 * @returns boolean indicating if timesheet_work_type is 'shifts'
 */
export const isShiftsWorkType = (contract: Contract | null): boolean => {
  return contract?.timesheet_work_type === 'shifts';
};
